import { Component, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { TopgradserviceService } from '../../topgradservice.service';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'app-change-password',
  templateUrl: './change-password.component.html',
  styleUrls: ['./change-password.component.scss']
})
export class ChangePasswordComponent implements OnInit {
  changepwdform: FormGroup;
  current_pwd: any;
  forgetForm: boolean= false;
  new_pwd: any;
  confirm_pwd: any;

  currentShowPassword: boolean = false;
  confirmShowPassword: boolean = false;
  newShowPassword: boolean = false;
  confirmInput: any;
  newInput: any;
  currentInput: any;
  userDetail = null;
  pass: String = 'password'
  constructor(private sanitizer: DomSanitizer, private Service: TopgradserviceService, private _snackBar: MatSnackBar, private _formBuilder: FormBuilder, private router: Router) {
    this.changepwdform = this._formBuilder.group({
      'current_pwd': ['', [Validators.required]],
      'new_pwd': ['', [Validators.required, Validators.pattern(
       /^(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*])[A-Za-z\d!@#$%^&*]{8,}$/
      ),]],
      'confirm_pwd': ['', [Validators.required]]

    }, {

      validator: [this.checkNotSamePassword, this.checkSamePassword]
    }
    )
  }

  onEyeClick(field: any, type: any) {
    console.log(field)
    if (field == 'pass') {
      this.pass = type
    }
  }

  ngOnInit(): void {
    this.userDetail = JSON.parse(localStorage.getItem("userDetail"));
    this.currentShowPassword = false;
    this.confirmShowPassword = false;
    this.newShowPassword = false;
  }
  ngOnChanges(): void {
    this.currentShowPassword = false;
    this.confirmShowPassword = false;
    this.newShowPassword = false;
  }

  checkSamePassword(group: FormGroup) {
    let pass = group.controls.current_pwd.value;
    let new_password = group.controls.new_pwd.value;
    let flag = false
    let returnable: any = {
      pwdSame: null
    }
    if (pass == new_password) {
      returnable.pwdSame = true
      flag = true
      console.log('same pwd=====')
    } return flag ? returnable : null
  }

  checkNotSamePassword(group: FormGroup) {
    let passs = group.controls.new_pwd.value;
    let confirm_password = group.controls.confirm_pwd.value;
    let flagg = false
    let returnablee: any = {
      pwdNotSame: null
    }
    if (passs != confirm_password) {
      returnablee.pwdNotSame = true
      flagg = true
    } return flagg ? returnablee : null
  }


  change() {
    console.log(this.changepwdform);
    if (this.changepwdform.invalid) {
      // this.changepwdform.markAllAsTouched()
      this._snackBar.open('Please fill all the required fields ', 'close', {
        duration: 2000
      })
      return false;
    } else {
      var obj = {
        old_password: this.changepwdform.value.current_pwd,
        new_password: this.changepwdform.value.new_pwd
      }
      this.Service.changePassword(obj).subscribe(data => {
        if (data.code = 200) {
          this._snackBar.open("Password changed successfully", "close", {
            duration: 2000
          });
          this.changepwdform.reset();
          localStorage.clear();
          if (this.userDetail?.role === 'student') {
            this.router.navigate(['/student-login']);
          } else if (this.userDetail?.role === 'employee') {
            this.router.navigate(['/employer-login']);
          }else {
            this.router.navigate(['login']);
          }
          this.forgetForm= true;
          
        }
      }, err => {
        console.log(err)
        if(err.status==409 && !err.message){
          this._snackBar.open("OTP is incorrect, please try again", "close", {
            duration: 2000
          });
        }else{
          this._snackBar.open(err.message?err.message:"Some Error Occued", "close", {
            duration: 2000
          });
        }
        

      })
    }

  }



  currentToggleShow() {
    this.currentShowPassword = !this.currentShowPassword;
  }
  newToggleShow() {
    this.newShowPassword = !this.newShowPassword;
  }
  confirmToggleShow() {
    this.confirmShowPassword = !this.confirmShowPassword;
  }

  cancel() {
    if (this.userDetail?.role === 'student') {
      this.router.navigate(['/student/dashboard']);
    } else if (this.userDetail?.role === 'employee') {
      this.router.navigate(['/employer/vacancies']);
    }
  }



  gotoLogin(){
    if (this.userDetail?.role === 'student') {
      this.router.navigate(['student-login']);
    } else if (this.userDetail?.role === 'employee') {
      this.router.navigate(['employer-login']);
    }else {
      this.router.navigate(['login']);
    }
  }
}
